import { DefaultState } from '@src/redux/types'

import {
  ST_COURSE_APPLICATION,
  ST_COURSE_APPLICATION_ALL,
  ST_COURSE_APPLICATION_CREATE,
  ST_COURSE_APPLICATION_DELETE,
  ST_COURSE_APPLICATION_FIELD_BATCH,
  ST_COURSE_APPLICATION_FIELD_BATCH_CREATE,
  ST_COURSE_APPLICATION_LIST,
  ST_COURSE_APPLICATION_REQUEST,
  ST_COURSE_APPLICATION_REQUEST_ALL,
  ST_COURSE_APPLICATION_REQUEST_EDIT,
  ST_COURSE_APPLICATION_REQUEST_UPDATE,
  ST_COURSE_APPLICATION_STATUS,
  ST_COURSE_APPLICATION_TYPES,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [ST_COURSE_APPLICATION]: DefaultState<`${typeof API.ST_COURSE_APPLICATION_FORM}{id}`, 'get'>
  [ST_COURSE_APPLICATION_ALL]: DefaultState<`${typeof API.ST_COURSE_APPLICATION_ALL}`, 'get'>
  [ST_COURSE_APPLICATION_CREATE]: DefaultState<`${typeof API.ST_COURSE_APPLICATION_FORM}`, 'post'>
  [ST_COURSE_APPLICATION_DELETE]: DefaultState<`${typeof API.ST_COURSE_APPLICATION_FORM}{id}`, 'delete'>
  [ST_COURSE_APPLICATION_FIELD_BATCH]: DefaultState<`${typeof API.ST_COURSE_APPLICATION_FIELD_BATCH}{id}`, 'get'>
  [ST_COURSE_APPLICATION_FIELD_BATCH_CREATE]: DefaultState<`${typeof API.ST_COURSE_APPLICATION_FIELD_BATCH}`, 'post'>
  [ST_COURSE_APPLICATION_LIST]: DefaultState<`${typeof API.ST_COURSE_APPLICATION}`, 'get'>
  [ST_COURSE_APPLICATION_REQUEST]: DefaultState<`${typeof API.ST_COURSE_APPLICATION_REQUEST}`, 'post'>
  [ST_COURSE_APPLICATION_REQUEST_ALL]: DefaultState<`${typeof API.ST_COURSE_APPLICATION_REQUEST_ALL}`, 'get'>
  [ST_COURSE_APPLICATION_REQUEST_EDIT]: DefaultState<`${typeof API.ST_COURSE_APPLICATION_REQUEST_EDIT}`, 'get'>
  [ST_COURSE_APPLICATION_REQUEST_UPDATE]: DefaultState<`${typeof API.ST_COURSE_APPLICATION_REQUEST_UPDATE}`, 'put'>
  [ST_COURSE_APPLICATION_STATUS]: DefaultState<`${typeof API.ST_COURSE_APPLICATION_STATUS}`, 'put'>
  [ST_COURSE_APPLICATION_TYPES]: DefaultState<`${typeof API.ST_COURSE_APPLICATION_TYPES}`, 'get'>
} = () => ({
  [ST_COURSE_APPLICATION]: defaultState(),
  [ST_COURSE_APPLICATION_ALL]: defaultState(),
  [ST_COURSE_APPLICATION_CREATE]: defaultState(),
  [ST_COURSE_APPLICATION_DELETE]: defaultState(),
  [ST_COURSE_APPLICATION_FIELD_BATCH]: defaultState(),
  [ST_COURSE_APPLICATION_FIELD_BATCH_CREATE]: defaultState(),
  [ST_COURSE_APPLICATION_LIST]: defaultState(),
  [ST_COURSE_APPLICATION_REQUEST]: defaultState(),
  [ST_COURSE_APPLICATION_REQUEST_ALL]: defaultState(),
  [ST_COURSE_APPLICATION_REQUEST_EDIT]: defaultState(),
  [ST_COURSE_APPLICATION_REQUEST_UPDATE]: defaultState(),
  [ST_COURSE_APPLICATION_STATUS]: defaultState(),
  [ST_COURSE_APPLICATION_TYPES]: defaultState(),
})
